import type { CardMetric, CardRow } from '@ctd/agent-contract';

/** A row's cell for one metric; the ids are the agent's, so only the row's own keys count. */
export function rowCell(
    row: CardRow,
    metricId: string
): CardRow['values'][string] | undefined {
    return Object.entries(row.values).find(([id]) => id === metricId)?.[1];
}

/** Whether any row carries a cell for the metric; a metric none does is drawn as its total only. */
export function hasRowCells(rows: CardRow[], metric: CardMetric): boolean {
    return rows.some((row) => rowCell(row, metric.id) !== undefined);
}
